// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__LsKwf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
}

.styles_title__uiWef {
  font-family: Poppins !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  line-height: 32px !important;
  color: #051433 !important;
}

.styles_qrCode__i52eg {
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 12px;
  width: 100%;
  border-bottom: 1px solid var(--gray-200, #F0F0F0);
  mix-blend-mode: multiply;
}

@media (max-width: 1440px) {
  .styles_qrCode__i52eg {
    padding: 0px;
  }
  .styles_title__uiWef {
    font-size: 16px !important;
  }
  .styles_container__LsKwf {
    padding-bottom: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/organisms/filterWindow/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AACJ;;AAEA;EACI,+BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,iDAAA;EACA,wBAAA;AACJ;;AAEA;EACI;IACI,YAAA;EACN;EACE;IACI,0BAAA;EACN;EACE;IACI,mBAAA;EACN;AACF","sourcesContent":[".container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom:12px\n}\n\n.title {\n    font-family: Poppins !important;\n    font-size: 18px !important;\n    font-weight: 700 !important;\n    line-height: 32px !important;\n    color: #051433 !important;\n}\n\n.qrCode {\n    display: flex;\n    padding: 12px;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    border-bottom: 1px solid var(--gray-200, #F0F0F0);\n    mix-blend-mode: multiply;\n}\n\n@media (max-width: 1440px) {\n    .qrCode {\n        padding: 0px;\n    }\n    .title {\n        font-size: 16px !important;\n    }\n    .container {\n        padding-bottom:8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__LsKwf`,
	"title": `styles_title__uiWef`,
	"qrCode": `styles_qrCode__i52eg`
};
export default ___CSS_LOADER_EXPORT___;
